import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/security/services/auth.service';
import { AppState } from '@core/store';
import { oficinaSelected } from '@core/store/selectors/oficinas.selectors';
import { Store } from '@ngrx/store';
import { CookiesService } from '@utils/services/cookies.service';
import { first, map, mergeMap, Observable, of, tap } from 'rxjs';
import { expiredCodeSumax, InterceptStrategy } from './InterceptStrategy';

@Injectable({ providedIn: 'root' })
export class SumaxErpInterceptStrategy implements InterceptStrategy {
	// Habilitar los proyectos a los que se realizan consultas
	sumaxErpBackendConOficina = [
		'sumax-erp-backend-aduanas',
		'sumax-erp-backend-emision-electronica',
		'sumax-erp-backend-deposito',
		'sumax-erp-backend-reportes',
		'sumax-erp-backend-informacion-operativa',
		'sumax-erp-backend-manifiesto',
	];
	endpoints = ['sumax-erp-backend-control-clientes', 'sumax-erp-backend-maestros', 'sumax-erp-backend-security', 'sumax-erp-backend-config', ...this.sumaxErpBackendConOficina];
	dmsUrls = ['/sgdcontenido', '/sgdtipodocumento', '/sgdtipoarchivo', '/sgdempresa'];
	secureUrls = ['/api/security/login', '/api/security/first-reset-password', '/api/security/change-password', '/api/security/refresh-token', '/api/security/signout'];

	constructor(
		private cookiesService: CookiesService,
		private authService: AuthService,
		// 		private auditService: AuditService, Habilitar si usan auditoría
		private storeAppState: Store<AppState>
	) {}

	isRefreshToken = true;

	isIntercepted(req: HttpRequest<any>): boolean {
		if (this.secureUrls.some((url) => req.url.includes(url))) return false;
		return this.endpoints.some((path) => req.url.includes(path));
	}

	additionalParams(req: HttpRequest<any>): Observable<Record<string, string>> {
		if (!this.sumaxErpBackendConOficina.some((path) => req.url.includes(path))) {
			return of({} as Record<string, string>);
		}
		return this.storeAppState.select(oficinaSelected).pipe(
			first(),
			map((oficina) => {
				if (this.dmsUrls.some((url) => req.url.includes(url))) {
					return {
						idOficina: oficina?.idOficina?.toString() || '',
						nroDocumentos: localStorage.getItem('nroDocumento') || '',
					} as Record<string, string>;
				}
				return {
					idOficina: oficina?.idOficina?.toString() || '',
				} as Record<string, string>;
			})
		);
	}

	getHttpRequest(req: HttpRequest<any>, additionalParams: Record<string, string>): HttpRequest<any> {
		const headers: Record<string, string> = {
			Authorization: this.cookiesService.getBearerAuthorization('idToken'),
		};
		if (additionalParams?.idOficina) {
			headers['idOficina'] = additionalParams.idOficina.toString();
		}
		if (this.dmsUrls.some((url) => req.url.includes(url))) {
			headers['nroDocumento'] = additionalParams.nroDocumento.toString();
		}
		// Habilitar si configuraron auditoria
		// const auditHeaders = this.auditService.getAuditHeaders();
		// if (auditHeaders) {
		// 	headers['Formulario'] = auditHeaders.formulario;
		//	headers['Accion-Formulario'] = auditHeaders.accionFormulario;
		//	headers['Proceso'] = auditHeaders.proceso;
		// }
		return req.clone({
			setHeaders: headers,
		});
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return error.status === 403 && error.error && expiredCodeSumax.includes(error.error.codigo);
	}

	refreshToken(req: HttpRequest<any>): Observable<Record<string, string>> {
		if (!this.sumaxErpBackendConOficina.some((path) => req.url.includes(path))) {
			return this.authService.refreshToken().pipe(tap((res) => this.authService.updateTokens(res.idToken!, res.accessToken!, res.maestroSyncToken!))) as unknown as Observable<Record<string, string>>;
		}
		return this.authService.refreshToken().pipe(
			tap((res) => this.authService.updateTokens(res.idToken!, res.accessToken!, res.maestroSyncToken!)),
			mergeMap(() => this.storeAppState.select(oficinaSelected).pipe(first())),
			map((oficina) => {
				if (this.dmsUrls.some((url) => req.url.includes(url))) {
					return {
						idOficina: oficina?.idOficina?.toString() || '',
						nroDocumentos: localStorage.getItem('nroDocumento') || '',
					} as Record<string, string>;
				}
				return {
					idOficina: oficina?.idOficina?.toString() || '',
				} as Record<string, string>;
			})
		) as unknown as Observable<Record<string, string>>;
	}
}
